import { mainTheme } from 'themes'

/**
 * @param {object} theme
 */
const styles = theme => {
    const { colors } = theme['foundations-library']

    return {
        audioControlContainer: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
            alignSelf: 'stretch'
        },
        progressAndTimingWrapper: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            alignSelf: 'stretch'
        },
        audioControlSeekbar: {
            cursor: 'pointer',
            height: 4,
            borderRadius: 2,
            position: 'relative',
            display: 'flex',
            flexGrow: 1,
            background: colors.neutral[100],
            '& .progress-bar': {
                background: colors.secondary[400],
                borderRadius: 2,
                position: 'relative',
                overflow: 'unset',
                height: '100%',
                width: 0,
                paddingBottom: 1,
                transition: 'background .1s',
                '& .player-control': {
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'center',
                    opacity: 1,
                    zIndex: 1,
                    width: '40px !important',
                    '&.force-show': {
                        opacity: 1,
                        '& .circle-icon': {
                            width: 18,
                            height: 18
                        }
                    },
                    '& .circle-icon': {
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        display: 'block',
                        userSelect: 'none',
                        userDrag: 'none',
                        width: 18,
                        height: 18,
                        transition: 'width .1s',
                        borderRadius: '50%',
                        border: '3px solid #FFF',
                        background: colors.primary[400]
                    }
                }
            },
            '& .temp-progress-bar': {
                background: '#fff',
                opacity: 0.35,
                borderRadius: 2,
                position: 'absolute',
                left: 0,
                top: 0,
                height: 4,
                width: 0
            }
        },
        seekBarErrorBorder: {
            border: theme ? theme.palette.error.flatBorder : mainTheme.palette.error.flatBorder
        },
        controlButton: {
            backgroundColor: `${colors.neutral[900]} !important`
        }
    }
}

export default styles
